function hideshowToggle(event) {
  var x = document.querySelector(".facets-wrapper");
    console.log("event.target=>",event.target);
    console.log("e.currentTarget=>",event.currentTarget);
    
  if (x.style.display === "none") {
    x.style.display = "block";
    event.currentTarget.classList.remove("open");
  } else {
    x.style.display = "none";
    event.currentTarget.classList.add("open");
  }
}

jQuery(".footer-block--menu .footer-block__heading").click(function(){
  if($(window).width() <= '749'){
  if(jQuery(this).hasClass("show"))
        {
          jQuery(this).removeClass("show");jQuery(this).next().slideUp();}
  else
        {
          jQuery(".footer-block--menu .footer-block__heading").removeClass("show");
          jQuery(".footer-block--menu .footer-block__heading").next().slideUp();
          jQuery(this).addClass("show");jQuery(this).next().slideDown();
        }
    }
});


